const styles = theme => ({
  // Preset strip (redesign)
  presetCard: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '14px 16px',
    background: '#FFFFFF',
    border: '1px solid #E5E7EB',
    borderRadius: '12px',
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  presetHead: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '12px',
  },
  presetToggle: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '14px',
    fontWeight: 600,
    color: '#002E47',
  },
  presetChevron: {
    width: 14,
    height: 14,
    color: '#637381',
    transition: 'transform 120ms',
  },
  presetCurrent: {
    fontSize: '12px',
    fontWeight: 400,
    color: '#637381',
  },
  presetActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  presetRow: {
    display: 'flex',
    gap: '10px',
    overflowX: 'auto',
    padding: '2px 2px 4px',
  },
  presetItem: {
    flex: '0 0 160px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    padding: '4px',
    borderRadius: '10px',
    background: '#FFFFFF',
    cursor: 'pointer',
    textAlign: 'left',
    fontFamily: 'inherit',
  },
  presetThumb: {
    position: 'relative',
    display: 'block',
    height: 78,
    borderRadius: '7px',
    backgroundColor: '#E5E7EB',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  presetBadge: {
    position: 'absolute',
    top: 6,
    right: 6,
    padding: '2px 6px',
    borderRadius: '4px',
    background: '#FFFFFF',
    fontSize: '9px',
    fontWeight: 700,
    letterSpacing: '.06em',
    color: '#002E47',
  },
  presetLabel: {
    padding: '0 4px 2px',
    fontSize: '13px',
    fontWeight: 500,
    color: '#002E47',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',
    alignSelf: 'stretch',
    borderRadius: '16px',
    background: 'var(--Background-Light-Paper, #FFF)',
  },
  headerContainer: {
    alignItems: 'center',
    gap: '8px',
    display: 'flex',
  },
  headerText: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '150%',
  },
  headerTextClose: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  close: {
    display: 'flex',
    gap: '16px',
  },
  icon: {
    width: 20,
    height: 20,
    padding: 1,
    cursor: 'pointer',
  },

  cardTop: {
    height: '90px',
    alignSelf: 'stretch',
    width: '100%',
  },
  cardText: {
    display: 'flex',
    padding: '12px',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    color: 'var(--Text-Light-Primary, #212B36)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
  },
  // Buton stilleri
  applyButton: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    backgroundColor: '#FFF',
  },
  applyButtonVisible: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'transparent',
    zIndex: 1000,
    marginBottom: '40',
  },
  templateContainer: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  template: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    gap: '16px',
    width: '100%',
    overflow: 'hidden',
  },
  navigationArrow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '40px',
    height: '40px',
    borderRadius: '50%',
    background: 'white',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    cursor: 'pointer',
    zIndex: 2,
    '&:hover': {
      background: '#f5f5f5',
    },
  },
  leftArrow: {
    position: 'absolute',
    left: '-20px',
  },
  rightArrow: {
    position: 'absolute',
    right: '-20px',
  },
  disabledArrow: {
    opacity: 0.5,
    cursor: 'not-allowed',
    '&:hover': {
      background: 'white',
    },
  },
  column: {
    flex: '0 0 calc(20% - 16px)',
    minWidth: '200px',
    overflow: 'hidden',
    border: '1px solid #E0E0E0',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
      border: '1px solid var(--mcg-blue, #015FFB)',
    },
    borderRadius: '16px',
  },
  templateWrapper: {
    position: 'relative',
    width: '100%',
  },
  navButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    background: '#fff',
    cursor: 'pointer',
    zIndex: 10,
    transition: 'all 0.2s ease',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  navButtonLeft: {
    left: '-20px', // -20px ile solda şablon konteyneri dışında kalır
  },
  navButtonRight: {
    right: '-20px', // -20px ile sağda şablon konteyneri dışında kalır
  },
  navButtonDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  navIcon: {
    color: '#002E47',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '16px',
  },
  paginationText: {
    fontSize: '14px',
    color: '#002E47',
  },
  template: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '16px',
    padding: '0 16px',
    position: 'relative',
    transition: 'transform 0.3s ease',
  },
})

export default styles
